import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    computed,
    ElementRef,
    inject,
    Input,
    linkedSignal,
    OnInit,
    signal,
    ViewChild,
    ViewEncapsulation,
    ViewRef,
} from "@angular/core";
import { EventService } from "../../services/event.service";
import { jSith } from "../../util/jquery-replacement";
import { S25Util } from "../../util/s25-util";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { PricingService } from "../../services/pricing.service";
import { RateService } from "../../services/rate.service";
import { TaxesService } from "../../services/taxes.service";
import { LangService } from "../../services/lang.service";
import { UserprefService } from "../../services/userpref.service";
import { FreshbooksService } from "../../services/freshbooks.service";
import { FlsService } from "../../services/fls.service";
import { OlsService } from "../../services/ols.service";
import { S25LoadingApi } from "../s25-loading/loading.api";
import { S25PricingOrgsComponent } from "./pricing-org-table-components/s25-pricing-orgs/s25.pricing.orgs.component";
import { S25PricingTotalsComponent } from "./pricing-org-table-components/s25-pricing-totals/s25.pricing.totals.component";
import {
    AccountOccurrenceSubtotal,
    AccountProfileSubTotal,
    EventPricingData,
    Invoice,
    FBInvoiceData,
    LineItem,
    PricingModel,
    PricingOrg,
    PricingOrgData,
    TotalsModel,
    InvoiceSummaryData,
    LineItemI,
    lineItemType,
    PrecheckedInvoiceData,
} from "../../pojo/Pricing";
import { Bind } from "../../decorators/bind.decorator";
import { S25ModalComponent } from "../s25-modal/s25.modal.component";
import { OptBean } from "../s25-opt/s25.opt.component";
import { StateService } from "../../services/state.service";
import { PricingOrgSummary } from "./pricing-org-table-components/s25-pricing-org-summary/s25.pricing.org.summary.component";
import { PreferenceService } from "../../services/preference.service";
import { BalanceUpdateService } from "./pricing-org-table-components/s25-pricing-organization/balance.update.service";
import { TelemetryService } from "../../services/telemetry.service";
import { AccessLevels, isMinFls } from "../../pojo/Fls";
import { S25PricingUtil } from "./s25.pricing.util";
import { S25ButtonComponent } from "../../standalone/s25.button.component";
import { S25PricingStore } from "./s25.pricing.store";

@TypeManagerDecorator("s25-ng-pricing")
@Component({
    selector: "s25-ng-pricing",
    template: `@if (init) {
        <s25-loading-inline [model]="{}"></s25-loading-inline>
        <div class="pricing_wrapper">
            @if (pricingInit) {
                @if (modelBean.canCreatePricingSet) {
                    <pricing-sidebar
                        [eventId]="+itemId"
                        [paymentsMode]="paymentsMode()"
                        [chosenInvoice]="modelBean.chosenPricingSet"
                        [canEdit]="canEditPricing"
                        [combineRelated]="optBean.combineRelatedEvents"
                        [(sidebarOpen)]="sidebarOpen"
                        (togglePricingSet)="togglePricingSet($event)"
                    ></pricing-sidebar>
                }
                <div class="pricing-main-content" [class.no-sidebar]="!modelBean.canCreatePricingSet">
                    <div
                        class="pricing-opt-wrapper"
                        [ngClass]="{ 'summary-view': summaryView, 'no-edit': !canEditPricing }"
                    >
                        @if (canEditPricing) {
                            <s25-ng-info-message [isPopover]="true" [class.close]="!sidebarOpen()">
                                {{ modeInfoMsg }}
                            </s25-ng-info-message>
                            <label>
                                Pricing Mode
                                <s25-toggle-button
                                    [modelValue]="paymentsMode()"
                                    [falseLabel]="'Standard'"
                                    [trueLabel]="'Payment'"
                                    (click)="toggleMode($event)"
                                ></s25-toggle-button>
                            </label>
                        }
                        <s25-ng-opt [modelBean]="optBean"></s25-ng-opt>
                    </div>
                    <!-- Standard Pricing Summary tab -->
                    @if (!paymentsMode()) {
                        <div class="pricing_header">
                            <span>{{ lang.summary }}</span>
                        </div>
                        <div class="pricing_date">
                            <span class="ngBold">{{ lang.pricing_date }}</span>
                            @if (!canEditPricing) {
                                <span class="c-margin-left--half">{{
                                    datePickerBean.date | dateFormat: datePickerBean.dateFormat
                                }}</span>
                            } @else {
                                <div class="date-picker-wrapper c-margin-left--half">
                                    <s25-datepicker
                                        [(modelValue)]="datePickerBean"
                                        (modelValueChange)="updateDate()"
                                    ></s25-datepicker>
                                </div>
                            }
                            <div class="c-margin-top--half">
                                <s25-ng-pricing-org-summary
                                    [modelBean]="orgSummaryBean"
                                    [summaryView]="summaryView"
                                    (signalScroll)="scrollToOrg($event)"
                                ></s25-ng-pricing-org-summary>
                            </div>
                        </div>
                    }
                    <div
                        class="invoice-dash"
                        [class.c-margin-bottom--single]="
                            optBean.combineRelatedEvents || summaryView || eventPricingData?.noOccs
                        "
                    >
                        <div
                            class="invoice-control-wrapper"
                            [ngClass]="{
                                'payments-mode': paymentsMode(),
                                'summary-view': summaryView,
                            }"
                        >
                            @if (canEditPricing && evBillId && !invoiceLocked) {
                                <label>
                                    Pricing Date:
                                    <s25-datepicker
                                        [(modelValue)]="datePickerBean"
                                        (modelValueChange)="updateDate()"
                                    ></s25-datepicker
                                ></label>
                            } @else if (evBillId) {
                                <!-- invoice view, invoice locked or insufficient edit perms --->
                                <label>
                                    Pricing Date:
                                    <p class="c-margin-top--half c-margin-left--quarter">
                                        {{ datePickerBean.date | dateFormat: datePickerBean.dateFormat }}
                                    </p>
                                </label>
                            }

                            @if (paymentsMode()) {
                                <s25-ng-pricing-org-summary
                                    [modelBean]="orgSummaryBean"
                                    [paymentsMode]="paymentsMode()"
                                ></s25-ng-pricing-org-summary>
                            }
                            @if (canEditPricing) {
                                @if (eventsNeedingRefresh?.length > 0 && !invoiceLocked) {
                                    <div>
                                        <div class="ngBold ngRed">
                                            The following events have been recently edited and may require a pricing
                                            refresh:
                                        </div>
                                        @for (event of eventsNeedingRefresh; track event) {
                                            <div>
                                                @if (!event.hideRefresh) {
                                                    <button
                                                        (click)="refreshPricing(event)"
                                                        class="aw-button aw-button--primary"
                                                    >
                                                        Refresh {{ event.event_name }}
                                                    </button>
                                                }
                                                @if (event.loading) {
                                                    <span>{{ event.loading }}</span>
                                                }
                                                @if (event.loadingSuccess) {
                                                    <span>{{ event.loadingSuccess }}</span>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                                @if (canEditPricing && paymentsMode() && !summaryView) {
                                    <div class="invoice-lock-wrapper">
                                        <s25-ng-info-message [isPopover]="true">{{
                                            invoiceLockInfoMsg
                                        }}</s25-ng-info-message>
                                        <label>
                                            Invoice Lock
                                            <s25-toggle-button
                                                [modelValue]="invoiceLocked"
                                                [falseLabel]="'Off'"
                                                [trueLabel]="'On'"
                                                (modelValueChange)="toggleLockInvoice($event)"
                                            ></s25-toggle-button>
                                        </label>
                                        <s25-loading-inline [model]="{ text: 'Saving...' }"></s25-loading-inline>
                                    </div>
                                }
                                @if (!optBean.combineRelatedEvents && !summaryView && !invoiceLocked) {
                                    <div class="update_rate_groups">
                                        <label for="allRateGroups"
                                            >Update All Items to Rate Group:
                                            <div class="rate_group c-margin-top--quarter">
                                                <s25-ng-pricing-rate-group
                                                    [modelBean]="eventRateGroupModel"
                                                    (updateRateGroup)="updateAllRateGroups($event)"
                                                ></s25-ng-pricing-rate-group>
                                            </div>
                                        </label>
                                    </div>
                                }
                                @if (!eventsNeedingRefresh?.length && !invoiceLocked) {
                                    <div class="invoice-buttons">
                                        <s25-ng-button
                                            #pricingRefreshButton
                                            (click)="refreshPricing(thisEvent)"
                                            [type]="'outline'"
                                        >
                                            Refresh this Event's Pricing
                                        </s25-ng-button>
                                    </div>
                                }
                                @if (paymentsMode() && modelBean.canCreatePricingSet && canEditPricing) {
                                    <div class="invoice-buttons">
                                        <button
                                            class="aw-button aw-button--outline"
                                            [disabled]="showSetDeleteWarning"
                                            (click)="modelBean.openPricingSetModal()"
                                        >
                                            Create Invoice
                                        </button>
                                    </div>
                                }
                                @if (
                                    modelBean.chosenPricingSet.id > 0 &&
                                    canEditPricing &&
                                    !modelBean.chosenPricingSet.billDefn.completed
                                ) {
                                    <div class="invoice-buttons">
                                        <button
                                            class="aw-button aw-button--outline"
                                            (click)="
                                                modelBean.openPricingSetModal([
                                                    { itemId: modelBean.chosenPricingSet.id, isInvoiceUpdate: true },
                                                ])
                                            "
                                        >
                                            Edit Invoice
                                        </button>
                                    </div>
                                }
                                @if (modelBean.chosenPricingSet.id > 0 && !invoiceDeleteDisabled() && canEditPricing) {
                                    <div class="invoice-buttons">
                                        <s25-ng-button
                                            [type]="'danger--outline'"
                                            [disabled]="showSetDeleteWarning"
                                            [onClick]="modelBean.deletePricingSet.bind(this)"
                                            >Delete Invoice</s25-ng-button
                                        >
                                    </div>
                                }
                            }
                        </div>
                        @if (evBillId) {
                            <included-occurrences
                                [selectedInvoice]="modelBean.chosenPricingSet"
                                [canEditPricing]="canEditPricing"
                                [isDashView]="true"
                                [combineRelatedEvents]="optBean.combineRelatedEvents"
                                [eventId]="+itemId"
                                (navToInvoice)="togglePricingSet({ id: $event })"
                                (refreshPricing)="optRefresh()"
                            ></included-occurrences>
                        }
                    </div>
                    @if (showSetDeleteWarning) {
                        <div class="warning-message">
                            At least one invoice is associated with this pricing set. Please confirm you'd like to
                            delete it.
                            <div class="button-container">
                                <button class="aw-button aw-button--outline" (click)="this.modelBean.cancelDelete()">
                                    Cancel
                                </button>
                                <button
                                    class="aw-button aw-button--danger--outline"
                                    (click)="modelBean.deletePricingSet()"
                                >
                                    Confirm
                                </button>
                            </div>
                        </div>
                    }
                    <s25-ng-modal
                        #pricingSetModal
                        [title]="(createInvoicePreCheckedData?.[0]?.isInvoiceUpdate ? 'Edit' : 'Create') + ' Invoice'"
                        [size]="'xl'"
                        (modalClosed)="createInvoicePreCheckedData = null"
                    >
                        <ng-template #s25ModalBody>
                            <s25-ng-pricing-set
                                [modelBean]="modelBean"
                                [eventId]="+itemId"
                                [combineRelatedEvents]="optBean.combineRelatedEvents"
                                [preCheckedData]="createInvoicePreCheckedData"
                                (close)="refresh()"
                                (navToInvoice)="togglePricingSet({ id: $event })"
                            ></s25-ng-pricing-set>
                        </ng-template>
                    </s25-ng-modal>
                    @if (!summaryView || (summaryView && (invoiceTotals || nonInvoicedData?.length))) {
                        <div>
                            <s25-ng-pricing-orgs
                                [evBillId]="evBillId"
                                [orgLists]="orgLists"
                                [optBean]="optBean"
                                [canEditPricing]="canEditPricing"
                                [summaryView]="summaryView"
                                [noOccs]="eventPricingData?.noOccs"
                                [freshbooksOrgSummary]="orgSummaryBean"
                                [paymentsMode]="paymentsMode()"
                                [invoiceLocked]="invoiceLocked"
                                [nonInvoicedData]="nonInvoicedData"
                                [openOrgTableIds]="openOrgTableIds"
                                [eventHasPayments]="eventHasPayments()"
                                [fbInvoiceData]="fbInvoiceData"
                                [updateColChooseBean]="updateColChooseBean"
                                [isDateRangeInvoice]="isDateRangeInvoice"
                                (refreshPricing)="refresh($event)"
                                (refreshOpt)="optRefresh($event)"
                                (manualPaymentCreated)="disableDeleteInvoice($event)"
                                (navToInvoice)="togglePricingSet({ id: $event })"
                                (openCreateInvoiceModal)="modelBean.openPricingSetModal($event)"
                            ></s25-ng-pricing-orgs>
                            <div class="pricing_header totals">{{ lang.totals }}</div>
                            <s25-ng-pricing-totals
                                [modelBean]="pricingTotalsModel"
                                [summaryView]="summaryView"
                                [invoiceData]="invoiceTotals"
                                [nonInvoicedLineItems]="summaryView && nonInvoicedData"
                            ></s25-ng-pricing-totals>
                        </div>
                    } @else {
                        <div class="noResults">No Invoices Found</div>
                    }
                </div>
            }
        </div>
        <s25-ng-modal
            #confirmToggleModal
            [title]="'Confirm Mode Change'"
            [type]="'custom'"
            [size]="promptForInvoiceConversion ? 'lg' : 'xs'"
        >
            <ng-template #s25ModalBody>
                <modal-convert-invoice
                    [modeInfoMessage]="modeInfoMsg"
                    [showInvoiceConvertData]="promptForInvoiceConversion"
                    [createStandardInvoice]="createStandardInvoice"
                    [combineRelatedEvents]="optBean.combineRelatedEvents"
                    [eventId]="+itemId"
                    [selectionsValidated]="standardInvoiceValidated"
                    [showErrors]="showStandardInvoiceErrors"
                    [dateFormat]="modelBean.dateFormat"
                    (updateMappingSelections)="eventPricingData = $event"
                ></modal-convert-invoice>
            </ng-template>
            <ng-template #s25ModalFooter>
                <div class="modal-create-invoice-buttons">
                    <s25-ng-button [type]="'primary'" [onClick]="onCreateStandardInvoice"> Confirm </s25-ng-button>
                    <button
                        class="aw-button aw-button--outline"
                        (click)="showStandardInvoiceErrors.set(false); toggleModal.close()"
                    >
                        Cancel
                    </button>
                </div>
            </ng-template>
        </s25-ng-modal>
    }`,
    styles: `
        @container main-content (width < 1100px) {
            .invoice-dash {
                flex-direction: column;
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    providers: [BalanceUpdateService],
    standalone: false,
})
export class S25PricingComponent implements OnInit {
    @Input() itemId: number | string;

    @ViewChild(S25PricingOrgsComponent) orgsLists: S25PricingOrgsComponent;
    @ViewChild(S25PricingTotalsComponent) totalsTable: S25PricingTotalsComponent;
    @ViewChild("pricingSetModal") pricingSetModal: S25ModalComponent;
    @ViewChild("confirmToggleModal") toggleModal: S25ModalComponent;
    @ViewChild("pricingRefreshButton") pricingRefreshButton: S25ButtonComponent;

    private pricingStore = inject(S25PricingStore);

    init = false;
    pricingInit = false;
    modelBean: PricingModel;
    optBean: OptBean = {} as OptBean;
    evBillId: number;
    orgLists: PricingOrg[];
    commonListBean: any;
    thisEvent: { event_id: number; loading?: string };
    eventIds: number[];
    eventsNeedingRefresh: { hideRefresh: boolean; event_name: string; loading: boolean; loadingSuccess: boolean }[] =
        [];
    dateTimeFormat: string;
    lang: any;
    canEditPricing: boolean;
    datePickerBean: any;
    orgSummaryBean: PricingOrgSummary;
    eventRateGroupModel: PricingOrgData;
    pricingTotalsList: any;
    pricingTotalsModel: TotalsModel;
    eventPricingData: EventPricingData;
    fbInvoiceData: FBInvoiceData;
    showSetDeleteWarning: boolean;
    invoiceDeleteDisabled = signal(false);
    selectedView: OptBean["selectedView"];
    paymentsMode = signal(null);
    sidebarOpen = signal<boolean>(true);
    modeInfoMsg: string =
        "Payment mode allows payment management and occurrence-based invoicing and reporting. Adjustments will only be reflected in the selected mode, and changing modes could result in billing discrepancies.";
    invoiceLockInfoMsg: string =
        'Invoice lock prevents adjustments, adding/removing occurrences, formula updates, reflection of reservation changes to associated occurrences, and changing the "Charge To" organization or Rate Group.';
    summaryView: boolean;
    invoiceLocked: boolean;
    invoiceTotals: InvoiceSummaryData;
    invoiceIdByOrg: { [key: number]: string };
    createStandardInvoice = signal<boolean>(false);
    promptForInvoiceConversion: boolean;
    standardInvoiceValidated = signal<boolean>(true);
    showStandardInvoiceErrors = signal<boolean>(false);
    nonInvoicedData: LineItemI[];
    openOrgTableIds = signal<number[]>(null);
    createInvoicePreCheckedData: PrecheckedInvoiceData;
    eventHasPayments = linkedSignal(() => !!Object.values(this.pricingStore.paymentSummary()).length);
    isDateRangeInvoice: boolean;

    invoices = computed(() => this.pricingStore.invoices());
    defaultInvoice = computed(() => ({
        id: this.paymentsMode() ? S25PricingUtil.SummaryViewId : S25PricingUtil.StandardPricingId,
        billDefn: {
            billName: this.paymentsMode() ? "Invoice Activity" : "Standard Pricing",
        },
    }));

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        this.elementRef.nativeElement.angBridge = this;
    }

    async ngOnInit() {
        if (!this.evBillId) {
            const urlArr = window.location.hash.split("/");
            const lastIndex: number | string = urlArr.at(-1);
            const location = urlArr.at(-2);
            const eventId = urlArr.at(-3);

            // when refreshing page, check url for data to persist current view - account for navigating from other sources (ie. search)
            if (
                S25Util.isDefined(lastIndex) &&
                !isNaN(+lastIndex) && // evBillId
                location === "pricing" && // is the pricing tab - necessary when navigating from search
                !isNaN(+eventId) &&
                eventId === this.itemId // make sure it's the same event, not a new one in which evBillId would not pertain
            ) {
                this.evBillId = +lastIndex;
                this.paymentsMode.set(true);
            }
        }
        this.selectedView = null;
        this.init = true;
        this.cd.detectChanges();

        S25LoadingApi.init(this.elementRef.nativeElement);

        this.modelBean = {
            canCreatePricingSet: false,
            openPricingSetModal: (preCheckedData?: PrecheckedInvoiceData) => {
                this.modelBean.pricingSet = {
                    itemId: +this.itemId,
                };
                if (preCheckedData) this.createInvoicePreCheckedData = preCheckedData;
                this.pricingSetModal.open();
            },
            selectPricingSet: async () => {
                this.evBillId =
                    this.modelBean.chosenPricingSet.id === this.defaultInvoice().id || !this.paymentsMode()
                        ? null
                        : this.modelBean.chosenPricingSet.id;

                this.summaryView = this.modelBean.chosenPricingSet.id === S25PricingUtil.SummaryViewId;
                if (!this.summaryView) this.selectedView = null;
                S25LoadingApi.init(this.elementRef.nativeElement);
                this.pricingInit = false;
                this.orgLists = [];
                this.cd.detectChanges();
                await this.initPricing();
                this.pricingInit = true;
                this.cd.detectChanges();
                S25LoadingApi.destroy(this.elementRef.nativeElement);
                window.scrollTo({ top: 0, behavior: "smooth" });
                StateService.go(
                    ".",
                    {
                        evBillId: this.evBillId ?? (this.paymentsMode() ? "summary" : ""),
                    },
                    {},
                );
            },
            deletePricingSet: async () => {
                if (this.invoiceDeleteDisabled()) return;

                if (this.fbInvoiceData?.customBillInvoices?.length > 0 && !this.showSetDeleteWarning) {
                    this.showSetDeleteWarning = true;
                    this.cd.detectChanges();
                    return;
                }
                try {
                    await PricingService.deletePricingSet(this.modelBean.chosenPricingSet.id);
                    this.modelBean.chosenPricingSet = this.defaultInvoice();
                    this.modelBean.selectPricingSet();
                    this.showSetDeleteWarning = false;
                } catch (error) {
                    S25Util.showError(error);
                }
            },
            cancelDelete: () => {
                this.showSetDeleteWarning = false;
                this.cd.detectChanges();
            },
        };

        this.itemId = +this.itemId;
        this.orgLists = this.orgLists || [];
        this.commonListBean = {
            comptype: "pricing",
            eventId: this.itemId,
            caption: "Pricing List",
        };

        this.optBean = Object.assign(this.optBean, {
            itemId: this.itemId,
            itemTypeId: 1,
            compsubject: "event",
            comptype: "pricing",
            helpTopic: "view_eventsingle_pricing",
            searchContext: "&pricing_event_id=" + this.itemId, //just used to make call unique to subject context if cached
            hasOpt: true,
            hasMoreActions: true,
            hasClose: true,
            hasRefresh: true,
            hasDatepicker: false,
            hasHideNoChargeItems: true,
            autoInit: false,
            hasBBStyle: false,
            refreshF: this.optRefresh,
            hasHelp: true,
            hasColumnChooser: true,
        });
        await this.initPricing();
        this.pricingInit = true;
        S25LoadingApi.destroy(this.elementRef.nativeElement);
        this.cd.detectChanges();
    }

    scrollToOrg(orgData: string) {
        this.orgsLists.scrollToOrg(orgData);
    }

    @Bind
    async refreshPricing(event: any) {
        try {
            this.pricingRefreshButton?.initLoading();
            await EventService.updateEventPricing(event.event_id);
            this.pricingRefreshButton?.clickPromiseHandler();
            return this.refresh();
        } catch (error) {
            S25Util.showError(error);
        }
    }

    async getEventsNeedingRefresh() {
        if (
            S25Util.array.shallowIntersection(this.eventIds, EventService.getEventIdsNeedingRefreshLocal(), null).length
        ) {
            this.eventsNeedingRefresh = await EventService.getEventsNeedingRefresh(this.eventIds);
        }
    }

    async initPricing() {
        this.thisEvent = { event_id: +this.itemId };
        const [
            eventPricingData,
            rateGroups,
            taxesMap,
            lang,
            dateFormat,
            dateTimeFormat,
            timeFormat,
            hasFreshbooks,
            fbInvoiceData,
            fls,
            ols,
            paymentsModePref,
            convertStandardPref,
        ] = await Promise.all([
            this.evBillId
                ? PricingService.getPricingFromPricingSetId(
                      +this.itemId,
                      this.evBillId,
                      this.optBean?.combineRelatedEvents,
                      this.pricingStore,
                  )
                : PricingService.getPricing(+this.itemId, this.optBean?.combineRelatedEvents, this.pricingStore),
            RateService.getRateGroups(),
            TaxesService.getTaxesMap(),
            LangService.getLang(),
            UserprefService.getS25Dateformat(),
            UserprefService.getS25DateTimeformat(),
            UserprefService.getS25Timeformat(),
            FreshbooksService.hasFreshbooksApiToken(),
            FreshbooksService.getS25Invoices(+this.itemId, this.evBillId),
            FlsService.getFls(),
            OlsService.getOls([+this.itemId], 1, "edit"),
            PreferenceService.getPreferences(["pricingMode"], "U"),
            PreferenceService.getPreferences(["createStandardInvoice"], "S"),
        ]);

        this.fbInvoiceData = fbInvoiceData?.invoice;
        if (S25Util.isUndefined(this.paymentsMode()))
            this.paymentsMode.set(paymentsModePref?.pricingMode?.value === "payment"); // only set to pref default on initial nav to view, allow toggle when user opts to change modes
        this.summaryView = !this.evBillId && this.paymentsMode();
        if (this.summaryView) this.selectedView = "occurrence";

        let editAccess = ols[0]?.access_level;
        this.modelBean.canCreatePricingSet =
            !!this.evBillId || [1, 2, 3].indexOf(parseInt(eventPricingData?.state)) > -1;
        !this.evBillId && this.pricingStore.setOccurrences(S25Util.deepCopy(eventPricingData.occurrences));
        this.eventPricingData = eventPricingData;
        this.createInvoicePreCheckedData = null;
        this.modelBean.canCreatePricingSet ? await this.setupInvoiceData() : this.sidebarOpen.set(false);
        this.promptForInvoiceConversion = !this.paymentsMode() && !this.invoices().length;
        this.createStandardInvoice.set(S25Util.toBool(convertStandardPref?.createStandardInvoice?.value));
        if (this.evBillId) {
            const chosenInvoice = this.invoices().find((set: Invoice) => set.id === this.evBillId);
            this.modelBean.chosenPricingSet = chosenInvoice ?? this.defaultInvoice();
            this.isDateRangeInvoice = !!chosenInvoice?.billDefn.startDt && !!chosenInvoice?.billDefn.endDt;
        } else {
            this.invoiceLocked = false;
            this.modelBean.chosenPricingSet = this.defaultInvoice();
            this.isDateRangeInvoice = false;
        }
        this.optBean.selectedView = this.selectedView;

        this.modelBean.dateTimeFormat = dateTimeFormat;
        this.modelBean.dateFormat = dateFormat;

        this.dateTimeFormat = dateTimeFormat;
        this.eventIds = eventPricingData?.eventIds;
        this.eventsNeedingRefresh = eventPricingData?.eventsNeedingRefresh;
        const relatedEventsNode = S25Util.propertyGet(eventPricingData, "content");
        //when combined, event data has no "content" tag bc all data has been merged into one "event" for combined pricing
        //so we always show the checkbox if combineRelatedEvents is true else users wont be able to uncheck it
        this.optBean.hasCombineRelatedEventsCheckbox =
            this.optBean.combineRelatedEvents || relatedEventsNode?.length > 0;
        this.canEditPricing =
            fls?.EVENT_BILLING === "F" && ["F", "C"].includes(editAccess) && ["F", "C", "R"].includes(fls?.CU_RATES);
        this.updateColChooseBean();

        const billItems = S25Util.propertyGet(eventPricingData, "bill_item") || [];
        let allOrgs = S25Util.propertyGet(eventPricingData, "organization") || [];
        const billedOrgs = S25Util.propertyGetAllUnique(
            this.summaryView ? this.invoiceTotals?.lineItems : eventPricingData,
            this.summaryView ? "chargeToId" : "charge_to_id",
        )?.map(S25Util.toInt);

        const invoiceOrgs = S25Util.propertyGetAllUnique(fbInvoiceData, "organization_id")?.map(S25Util.toInt);
        if (this.summaryView && this.invoiceTotals) {
            const eventId = eventPricingData?.event_id;
            this.nonInvoicedData =
                eventPricingData?.bill_item?.filter((lineItem: LineItemI) => {
                    lineItem.eventId = eventId;
                    if (lineItem.occurrences?.length) {
                        lineItem.occurrences = lineItem.occurrences.filter(
                            (occ) => !this.invoiceTotals.invoicedItems.occs.has(occ.rsrvId),
                        );
                    }
                    return (
                        lineItem.occurrences?.length || // associated with a non-invoiced occurrence
                        (lineItem.bill_item_type_id > 0 && // non-invoiced line item not associated with occurrence
                            !lineItem.occurrences &&
                            !this.invoiceTotals.invoicedItems.lineItems.has(
                                `${lineItem.bill_item_id}-${lineItem.bill_item_type_id}`,
                            ))
                    );
                }) ?? [];

            if (this.nonInvoicedData.length)
                allOrgs = [
                    { organization_id: S25PricingUtil.NonInvoicedOrgId, organization_name: "Non-Invoiced Billing" },
                    ...allOrgs,
                ];
            this.invoiceTotals.orgs = allOrgs;
        }

        this.lang = lang?.div?.controls["s25-event_details"]?.text;

        this.datePickerBean = {
            dateFormat: dateFormat,
            date:
                new Date(
                    S25Util.date.dropTZString(
                        S25Util.propertyGet(
                            S25Util.propertyGetParentWithChildValue(eventPricingData, "history_type_id", 4),
                            "history_dt",
                        ),
                    ),
                ) || new Date(),
            showToday: true,
        };

        this.orgSummaryBean = {
            billedOrgs: billedOrgs,
            invoiceOrgs: invoiceOrgs,
            allOrgs: allOrgs,
            eventId: +this.itemId,
            relatedEventIds: this.eventIds?.filter((id) => id !== this.itemId) ?? [],
            hasFreshbooks: hasFreshbooks,
            evBillId: this.evBillId,
            invoices: this.invoices(),
        };

        this.eventRateGroupModel = {
            rateGroups: rateGroups,
            eventId: +this.itemId,
            canEdit: true,
            canEditPricing: this.canEditPricing,
            isEventLevel: true,
            evBillId: this.evBillId,
            fls: fls,
            eventData: eventPricingData,
        };

        jSith.forEach(allOrgs, (_, org) => {
            org.isBillingOrg = billedOrgs.indexOf(parseInt(org.organization_id)) > -1;
            const isNonInvoicedData = org.organization_id === S25PricingUtil.NonInvoicedOrgId;
            // billedOrgs is set by standard event pricing line items, for summary view we aggregate invoice line items
            if (org.isBillingOrg || isNonInvoicedData) {
                let orgListData;
                if (this.summaryView && (this.invoiceTotals || isNonInvoicedData)) {
                    orgListData = {
                        rows:
                            Object.values(
                                isNonInvoicedData ? this.nonInvoicedData : this.invoiceTotals?.lineItems,
                            )?.filter((lineItem: LineItem) => {
                                const chargeToId = lineItem.chargeToId ?? S25PricingUtil.NonInvoicedOrgId;
                                return (
                                    chargeToId === org.organization_id &&
                                    (this.optBean.combineRelatedEvents
                                        ? eventPricingData?.eventIds?.includes(lineItem.eventId)
                                        : lineItem.eventId === eventPricingData?.event_id)
                                );
                            }) ?? [],
                        orgId: org.organization_id,
                        rateGroups: rateGroups,
                        allOrgs: allOrgs,
                        rateSchedules: this.invoiceTotals?.rateSchedules,
                        subtotals: this.invoiceTotals?.subtotals[org.organization_id] ?? {},
                    };
                } else {
                    orgListData = S25PricingUtil.getPricingOrganizationListModelData(
                        eventPricingData,
                        +this.itemId,
                        parseInt(org.organization_id),
                        rateGroups,
                        taxesMap,
                        this.canEditPricing,
                    );
                }

                Object.assign(orgListData, {
                    combineRelatedEvents: !!this.optBean.combineRelatedEvents,
                    fls: fls,
                    dateFormat: dateFormat,
                    occSubtotals: {},
                    datePrefs: {
                        dateFormat,
                        dateTimeFormat,
                        timeFormat,
                    },
                    profileSubtotals: [],
                    hideNoChargeItems: this.optBean.hideNoChargeItems,
                });

                eventPricingData?.occSubtotals?.forEach((item: AccountOccurrenceSubtotal) => {
                    if (
                        item.chargeToId === org.organization_id || // invoiced occurrence
                        (org.organization_id < 0 && !this.invoiceTotals.invoicedItems.occs.has(item.rsrvId)) // non-invoiced occurrence
                    ) {
                        orgListData.occSubtotals[item.rsrvId] = item;
                    }
                });

                eventPricingData?.profileSubtotals?.forEach((item: AccountProfileSubTotal) => {
                    if (item.chargeToId === org.organization_id) {
                        orgListData.profileSubtotals.push(item);
                    }
                });

                const orgInList = S25Util.array.getByProp(this.orgLists, "orgId", org.organization_id);
                const canEditInvoiceNum = isMinFls(fls?.MANAGE_PAY, AccessLevels.Read);

                if (orgInList) {
                    //organization list already exists, just reset its getdata function
                    //and set some other info, mainly subTotal sub-section so that grand totals are updated...
                    //and hasEventCharges so create invoice btn shows if charges were added
                    Object.assign(orgInList, {
                        data: orgListData,
                        rowFuncs: S25PricingUtil.getPricingOrganizationListFn(orgListData),
                        hasEventCharges:
                            S25PricingUtil.agg.totalCharge.total(
                                billItems.filter(S25PricingUtil.billItemOrgFilter(org.organization_id)),
                            ) > 0,
                        subTotal: S25PricingUtil.getSubTotalObject(org, orgListData?.allBillItems),
                        evBillId: this.evBillId,
                        canEditInvoiceNum: canEditInvoiceNum,
                        invoiceNum: this.evBillId ? (this.invoiceIdByOrg[org.organization_id] ?? "") : null,
                    });
                } else {
                    //create organization lists
                    this.orgLists.push(
                        S25Util.merge(S25Util.deepCopy(this.commonListBean), {
                            hasFreshbooks: hasFreshbooks,
                            data: orgListData,
                            rowFuncs: S25PricingUtil.getPricingOrganizationListFn(orgListData),
                            orgId: org.organization_id,
                            orgName: (org.organization_name?.toString() || "").toUpperCase(),
                            hasEventCharges:
                                !this.summaryView &&
                                S25PricingUtil.agg.totalCharge.total(
                                    billItems.filter(S25PricingUtil.billItemOrgFilter(org.organization_id)),
                                ) > 0,
                            subTotal:
                                !this.summaryView && S25PricingUtil.getSubTotalObject(org, orgListData?.allBillItems),
                            total: !this.summaryView && S25PricingUtil.agg.totalCharge.total(orgListData?.allBillItems),
                            evBillId: this.evBillId,
                            canEdit: this.canEditPricing,
                            canEditInvoiceNum: canEditInvoiceNum,
                            invoiceNum: this.evBillId ? (this.invoiceIdByOrg[org.organization_id] ?? "") : null,
                        }),
                    );
                }
            }
        });

        if (this.summaryView && this.orgLists.length > 1 && this.nonInvoicedData.length) {
            // keep non-invoiced table at top, sort org tables alphabetically after
            this.orgLists = [this.orgLists[0], ...this.orgLists.slice(1).sort(S25Util.shallowSort("orgName"))];
        } else {
            this.orgLists.sort(S25Util.shallowSort("orgName"));
        }
        if (!this.openOrgTableIds()) this.openOrgTableIds.set(this.orgLists?.map((org) => +org.orgId));
        const pricingTotalsModel: TotalsModel = {
            evBillId: this.evBillId,
            taxesMap: taxesMap,
            grandTaxes: { tax: [] },
            rows: [],
            combineRelatedEvents: this.optBean.combineRelatedEvents,
        };

        jSith.forEach(this.orgLists, (_, org) => {
            //add flag on each org to indicate if related events are available
            if (!this.summaryView) {
                org.hasRelatedEvents = this.optBean.combineRelatedEvents || relatedEventsNode?.length;
                pricingTotalsModel.grandPriceList = (pricingTotalsModel.grandPriceList || 0) + org.subTotal.list_price; //accumulate list price from each org
                pricingTotalsModel.grandAdjustmentAmt =
                    (pricingTotalsModel.grandAdjustmentAmt || 0) + org.subTotal.adjustment_amt; //accumulate adj amt from each org
                pricingTotalsModel.rows.push(org.subTotal); //place org sub total row in array
            }
        });

        billItems?.forEach((item: any) => {
            if (parseInt(item.bill_item_type_id) === lineItemType.ADJUSTMENT) {
                pricingTotalsModel.grandAdjustmentAmt += parseFloat(item.total_charge);

                pricingTotalsModel.rows.push({
                    evBillId: this.evBillId,
                    isAdjustment: true,
                    adjustment_name: item.adjustment_name,
                    total_charge: item.total_charge,
                    charge_to_name: item.charge_to_name,
                    charge_to_id: item.charge_to_id,
                    adjustment_amt: item.adjustment_amt,
                    adjustment_percent: item.adjustment_percent,
                });
            }
        });

        pricingTotalsModel.grandTaxableAmt = S25PricingUtil.agg.adjustedPrice.subtotal(billItems);
        pricingTotalsModel.grandTotalCharge = S25PricingUtil.agg.totalCharge.total(billItems);
        pricingTotalsModel.grandTaxes.tax = S25PricingUtil.agg.taxes.totalByTaxId(billItems, taxesMap);
        this.pricingTotalsModel = pricingTotalsModel;
        if (this.pricingTotalsList) {
            this.pricingTotalsList.getdata = S25PricingUtil.getPricingTotalsListFn(pricingTotalsModel);
        } else {
            this.pricingTotalsList = S25Util.merge(
                S25Util.copy(this.commonListBean, {
                    getdata: S25PricingUtil.getPricingTotalsListFn(pricingTotalsModel),
                }),
            );
        }
    }
    @Bind
    async refresh(totalsRefreshData?: any) {
        if (!this.optBean.combineRelatedEvents && totalsRefreshData) {
            this.totalsTable.initTableConfig(totalsRefreshData);
            return;
        }

        this.init = false;
        this.pricingInit = false;
        this.orgLists = [];
        this.cd.detectChanges();

        await this.ngOnInit();

        setTimeout(() => {
            this.cd && !(this.cd as ViewRef).destroyed && this.cd.detectChanges();
        });
    }

    @Bind
    async optRefresh(selectedView?: OptBean["selectedView"]) {
        if (this.evBillId && !this.invoiceIsRelated()) {
            this.modelBean.chosenPricingSet = this.defaultInvoice();
            return this.modelBean.selectPricingSet();
        }
        this.selectedView =
            !!selectedView || selectedView === null // if passed-in view param is null, it was set intentionally to reset, or if defined use that value
                ? selectedView
                : (this.orgsLists?.selectedView ?? this.selectedView); //if no param is passed into refresh function, maintain current view if defined
        const expandedTableMap = this.orgsLists?.orgTableExpandMap();
        expandedTableMap &&
            this.openOrgTableIds.set(
                Object.entries(expandedTableMap)
                    .filter(([_, table]) => table.isOpen)
                    .map(([orgId]) => +orgId),
            );
        S25LoadingApi.init(this.elementRef.nativeElement);
        this.pricingInit = false;
        this.orgLists = [];
        this.cd.detectChanges();

        await this.initPricing();

        this.pricingInit = true;
        S25LoadingApi.destroy(this.elementRef.nativeElement);

        setTimeout(() => {
            this.cd && !(this.cd as ViewRef).destroyed && this.cd.detectChanges();
        });
    }

    updateAllRateGroups(tableData: any) {
        this.orgsLists.refreshAllRateGroups(tableData);
    }

    getColChooseBean() {
        const occurrenceView =
            this.selectedView === "occurrence" || this.orgsLists?.selectedView === "occurrence" || this.summaryView;
        const colList = S25PricingUtil.PricingConst.cols
            .filter((col) =>
                !occurrenceView ||
                this.isDateRangeInvoice ||
                (!this.canEditPricing && !this.summaryView) ||
                !this.paymentsMode()
                    ? col.prefname !== "invoice"
                    : true,
            )
            .map((obj: any) => {
                obj.isVisible = 1;
                return obj;
            });

        if (!this.optBean || !S25Util.coalesce(this.optBean.combineRelatedEvents, false)) {
            S25Util.array.inplaceRemoveByProp(colList, "prefname", "reference"); //no reference column if not combining related events...
        }

        return {
            //get list of columns available, set all to visible (checked)
            colList: colList,
            updateCallback: () => this.updateTableColumns(),
        };
    }

    @Bind
    updateTableColumns() {
        this.orgsLists?.updateColumns();
    }

    async updateDate() {
        const [_, error] = await S25Util.Maybe(
            PricingService.putPricingBillingDate(+this.itemId, this.datePickerBean, this.evBillId),
        );
        if (error) return S25Util.showError(error);
        return this.optRefresh();
    }

    disableDeleteInvoice(evBillId: number) {
        // manual payment created - disable delete invoice and hide freshbooks section
        this.invoiceDeleteDisabled.set(evBillId === this.evBillId);
        this.eventHasPayments.set(true);
    }

    togglePricingSet(set: Invoice) {
        if (!this.paymentsMode()) return;
        this.modelBean.chosenPricingSet = set;
        this.modelBean.selectPricingSet();
    }

    async toggleMode(event: Event) {
        TelemetryService.send("EventDetails", "PaymentMode");
        event.preventDefault();
        await this.toggleModal.open();
    }

    @Bind
    async onCreateStandardInvoice() {
        if (this.standardInvoiceValidated() || !this.promptForInvoiceConversion) {
            this.createStandardInvoice() &&
                this.promptForInvoiceConversion &&
                (await PricingService.postStandardInvoice(this.eventPricingData));
            this.paymentsMode.update((prev) => !prev);
            PreferenceService.setPreference("pricingMode", this.paymentsMode() ? "payment" : "standard", "U");
            this.optBean.combineRelatedEvents = false;
            this.modelBean.chosenPricingSet = this.defaultInvoice();
            this.selectedView = null;
            this.sidebarOpen.set(true);
            await this.toggleModal.close();
            this.modelBean.selectPricingSet();
        } else {
            this.showStandardInvoiceErrors.set(true);
        }
    }

    async setupInvoiceData() {
        const invoiceResp = await PricingService.getInvoices(
                +this.itemId,
                this.optBean.combineRelatedEvents,
                this.pricingStore,
            ),
            invoices = S25Util.array.uniqueByProp(invoiceResp?.data?.items ?? [], "id");
        if (this.summaryView || this.evBillId) {
            const { rateGroups, rateSchedules } = invoiceResp?.expandedInfo ?? {};
            const invoiceData: InvoiceSummaryData = {
                lineItems: {},
                subtotals: {} as InvoiceSummaryData["subtotals"],
                rateGroups,
                rateSchedules,
                invoicedItems: { occs: new Set(), lineItems: new Set(), invoiceNamesAndIds: [] },
            };
            invoices.forEach((invoice: Invoice) => {
                if (invoice.id === this.evBillId) {
                    this.invoiceDeleteDisabled.set(invoice.payments?.length > 0);
                    this.invoiceLocked = !!invoice.billDefn.completed;
                    this.invoiceIdByOrg = invoice.billing.subtotals[0].account?.reduce(
                        (map: { [key: number]: string }, orgData) => (
                            (map[orgData.chargeToId] = orgData.invoiceId), map
                        ),
                        {},
                    );
                }
                S25PricingUtil.getSummaryData(invoice, invoiceData, this.optBean.combineRelatedEvents, +this.itemId);
            });

            this.invoiceTotals = invoiceData;
            this.pricingStore.setInvoiceSummaryData(this.invoiceTotals.invoicedItems.invoiceNamesAndIds);
            if (this.summaryView) {
                S25PricingUtil.sortOccurrenceItems(this.invoiceTotals);
            }
        }
    }

    async toggleLockInvoice(locked: boolean) {
        const lockWrapper = this.elementRef.nativeElement.querySelector(".invoice-lock-wrapper");
        lockWrapper && S25LoadingApi.init(lockWrapper);
        const [_, error] = await S25Util.Maybe(PricingService.putBillingCustom({ completed: locked }, this.evBillId));
        lockWrapper && S25LoadingApi.destroy(lockWrapper);
        if (error) return S25Util.showError(error);
        return this.refresh();
    }

    invoiceIsRelated() {
        const invoice = this.invoices().find((invoice) => invoice.id === this.evBillId);
        const associatedEvents = invoice?.billDefn.events;
        return associatedEvents?.includes(+this.itemId);
    }

    @Bind
    updateColChooseBean() {
        this.optBean.colChooseBean = this.getColChooseBean();
    }
}
